import React from "react"

// Components
import AppCanvasLoader from '../Global/AppCanvasLoader';

const AdminLoader = () => (
  <div className="dashboard-loader-container">
    <AppCanvasLoader />
  </div>
)

export default AdminLoader



// WEBPACK FOOTER //
// ./src/components/Admin/AdminLoader.js